export default function CommonBadge({ text, icon }) {   
    return (
        <div className="flex items-center gap-1 px-2 py-0.5 border
         rounded-full w-fit bg-light-gray/10 text-light-gray text-12 font-text border-stroke/10">
        {icon}
        {text}
    </div>
    );
}
